import { render, staticRenderFns } from "./EditCoordinator.vue?vue&type=template&id=095957b6&scoped=true&"
import script from "./EditCoordinator.vue?vue&type=script&lang=js&"
export * from "./EditCoordinator.vue?vue&type=script&lang=js&"
import style0 from "./EditCoordinator.vue?vue&type=style&index=0&id=095957b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095957b6",
  null
  
)

export default component.exports